var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticStyle:{"border":"0px solid #666666"},attrs:{"id":"round_stamp","width":"65","height":"65"}})}
var staticRenderFns = []

export { render, staticRenderFns }